import { StyleProvider } from '@ant-design/cssinjs';
import { ConfigProvider } from 'antd';
import type { ReactNode } from 'react';

/**
 * antd emite sus estilos en `@layer antd` (orden declarado en src/styles/index.css),
 * para que las utilidades de Tailwind le ganen y el preflight no lo pise.
 */
export function AntdLayerProvider({ children }: { children: ReactNode }) {
  return <StyleProvider layer>{children}</StyleProvider>;
}

// Los métodos estáticos (message, notification, Modal.confirm…) se montan fuera del árbol:
// también deben emitir en la capa antd.
ConfigProvider.config({
  holderRender: (children) => <AntdLayerProvider>{children}</AntdLayerProvider>,
});
